import { useTranslation } from "react-i18next";
import { Search, Handshake, FileSignature } from "lucide-react";
import SmartImage from "@/components/ui/smart-image";

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    {
      Icon: Search,
      title: t("howItWorks.step1Title"),
      desc: t("howItWorks.step1Desc"),
      img: "/assets/images/Property_search_interface_a19e05cb.png",
      tone: "from-primary/10 to-primary/0 border-primary/15 text-primary",
    },
    {
      Icon: Handshake,
      title: t("howItWorks.step2Title"),
      desc: t("howItWorks.step2Desc"),
      img: "/assets/images/Negotiation_dashboard_interface_766d7bbe.png",
      tone: "from-accent/10 to-accent/0 border-accent/15 text-accent",
    },
    {
      Icon: FileSignature,
      title: t("howItWorks.step3Title"),
      desc: t("howItWorks.step3Desc"),
      img: "/assets/images/Digital_contract_signing_4a199e49.png",
      tone: "from-brand-teal/10 to-brand-teal/0 border-brand-teal/20 text-brand-teal",
    },
  ];

  return (
    <section id="how-it-works" className="section bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 max-w-3xl mx-auto">
          <div className="inline-block trust-pill mb-4">How it works</div>
          <h2 className="font-display text-display-lg text-foreground mb-4">
            {t("howItWorks.title")}
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            {t("howItWorks.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {steps.map(({ Icon, title, desc, img, tone }, i) => (
            <div
              key={title}
              className="group relative overflow-hidden rounded-2xl border border-border bg-card p-6 sm:p-7 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ease-emphasized"
              data-testid={`step-${i}`}
            >
              <div className={`absolute inset-x-0 top-0 h-32 bg-gradient-to-b ${tone} pointer-events-none`} />
              <div className="relative">
                <div className="flex items-center justify-between mb-5">
                  <div className={`w-12 h-12 rounded-xl border bg-card shadow-xs flex items-center justify-center ${tone}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="font-display text-4xl font-bold text-foreground/10 leading-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-foreground mb-2.5">
                  {title}
                </h3>
                <p className="text-muted-foreground mb-5 leading-relaxed">{desc}</p>
                <SmartImage
                  src={img}
                  alt=""
                  width={400}
                  height={200}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  widths={[300, 400, 600, 800]}
                  className="w-full h-32 object-cover rounded-lg border border-border"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
